module.exports = __webpack_public_path__ + "Diplomain3DEnvironmentArtCreationforGames-9376cfe5.webp";